import React from "react";
import styled from 'styled-components';
import { connect } from 'react-redux';
import Scrollbars from "react-custom-scrollbars";
import Button from '../../../atoms/button';
import ModuleCategory from '../../../components/module_category';
import LoadingSpinner from '../../../atoms/loading';
import I10n from '../../../features/i10n';
import { getQuestions } from '../../question-management/ducks';
import { getCompatibleModules } from '../../get-modules/ducks';
import MsxIcons from "../../msx-icons";
import { configurationModuleType } from '../../../constants';
import { getAppLocale } from "../../../utils/app-locale";
import ProductCategory from "../../../models/ProductCategory";
import Select from 'react-select';
import FilterContent from "../../../components/question_list_filter_answer";
import FilterHead from "../../../components/question_list_filter_header";
import { PRIMARY_COLOR } from "../../../color-constants";
import PrecommercializationWarning from "../../../components/precommercialization_warning";
import { setShowPrecommercializedProducts } from "../../configuration-management/ducks";
import { computeEligibleCategories, shouldShowPrecommToggle } from "../../../utils/module-category";

const Container = styled.div`
  border-radius: 10px;
  align-self: center;
  display: flex;
  flex-direction: column;
  margin: 2em;
  max-width: 1100px;
  width: 100%;
  background-color: white;
  height: calc(100vh - 4em);
  overflow: hidden;
  @media (max-width: 800px) {
    max-width: 100%;
    margin: 2em 0;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background-color: white;
  color: ${PRIMARY_COLOR};
  color: var(--se-primary, ${PRIMARY_COLOR});
  margin: 0px 20px;
  padding: 10px 0px;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  padding: 16px 0;
  align-items: stretch;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  border-top: 2px solid #cccc;
  @media (max-width: 800px) {
    min-height: auto;
    display: none;
  }
  ${props => props.fullScreenEnabled && `
    min-height: auto;
  `}
`;

const Content = styled.div`
  flex: 1 1 auto;
  position: relative;
  display: flex;
  flex-direction: row;
  background-color: #F4F4F4;
  border-bottom: 2px solid #cccccc;
`;

const Title = styled.span`
  font-weight: bold;
  font-size: 20px;
`;

const CloseIcon = styled.span`
  display: inline-block;
  color: #626469;
  cursor: pointer;
`;

const SearchReferenceInput = styled.input`
  border-radius: 20px;
  height: 30px;
  width: 100%;
  max-width: none;
  padding: 5px;
  border: 1px solid #E6E6E6;
  color: #A4A4A4;
  font-size: 13px;
  font-weight: 400;
  line-height: 15px;
  color: #9FA0A4;
`;

const DeviceSectionContent = styled.div`
  position: relative;
  flex: 1 1 0px;
  background-color: #F4F4F4;
  margin: 0 10px;
  overflow: auto;
`;

const DeviceSection = styled.section`
  display: flex;
  flex-direction: column;
  flex: 2 1 0px;
  margin-bottom: 5px;
  @media (max-width: 800px) {
    margin-left: 0;
    min-height: auto;
  }
`;

const MobileQuestionManagement = styled.div`
  display: none;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
  @media (max-width: 800px) {
    display: flex;
  }
`;

const LoadingMask = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
  background-color: grey;
  z-index: 1;
  opacity: 0.2;
`;

const AddModuleSection = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

const NavigationButtonSection = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  @media (max-width: 800px) {
    justify-content: center;
  }
`;

const QuantityLabel = styled.span`
  margin-right: 10px;
  font-size: 14px;
`;

const MultipleAdditionWrapper = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 800px) {
    margin-bottom: 5px;
  }
`;

const SearchBarWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
  margin-left: 10px;
`;

const SearchBar = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 30px;
  box-sizing: border-box;
  margin-top: 10px;
  margin-bottom: 10px;
  position: relative;
`;

const SearchBarTestWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  background-color: #F4F4F4;
  padding: 0px 15px;
`;

const FilterHeadWrapper = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: auto;
  ${props => props.isHidden ? 'visibility: hidden;' : ''}

   @media (max-width: 800px) {
  }
`;

const FilterContentWrapper = styled.div`
  width: ${props => props.isFilterOpen ? '350px' : '0'};
  display: ${props => props.isFilterOpen ? 'flex' : 'none'};
  margin-top:${props => props.isFilterOpen ? '-39px' : '0'};
  padding-left: ${props => props.isFilterOpen ? '16px' : '0' };
  position: relative;

  @media (max-width: 800px) {
    background-color: #F4F4F4;
    flex-grow: 1;
    position: absolute;
    top: 50px;
    bottom: 0px;
    z-index: 1000;
    width: 100%;
    left: 0;
    right: 0;
    box-sizing: border-box;
    padding-left: 15px;
    padding-right: 15px;
  }
`;

const Subtitle = styled.div`
  font-size: 14px;
  color: #626469;
  margin-top: 5px;
`;

const Test = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

const ContentWrapperMobile = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-top: 2px solid #cccc;
  padding: 10px 15px 0 15px;
`;

const SearchBarTestWrapperMobile = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const SearchBarWrapperMobile = styled.div`
  flex-grow: 1;
  width: 100%;
  margin-top: 10px;
`;

const SearchBarMobile = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1 0px;
`;

const SearchBarIcon = styled.div`
  position: absolute;
  left: 13px;
`;

const FilterHeadWrapperMobile = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: auto;
  width: 100%;
  ${props => props.isHidden ? 'visibility: hidden;' : ''}
`;

const PrecommWrapper = styled.div`
  display: flex;
  margin-left: 5px;
`;

const MobilePrecommWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 10px;
`;

class ModalAddModule extends React.PureComponent {

  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      search: '',
      moduleSelected: null,
      moduleSelectedMaxAmount: 0,
      selectedDeviceAmount: 1,
      categories: this.filterCategories(props.categories),
      baseKey: props.baseKey ? props.baseKey : 'add_module',
      remainingCriteria: props.remainingCriteria,
      sharedOptions: props.sharedOptions,
      baseCriteria: props.remainingCriteria,
      questionsWithAnswers: {},
      openMobileQuestionsCallback: null,
      isFilterOpen: window.innerWidth > 800
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.props.getAggregatedQuestions(this.props.questionType);
    if (this.props.loadModulesAtStart) {
      this.refreshModules({});
    }
  }


  componentWillUnmount() {
    this._isMounted = false;
  }

  removeSelectedModuleIfNotInResult(references) {
    const referencesId = references.map((e) => { return e.id; });
    if (this.state.moduleSelected) {
      if (referencesId.indexOf(this.state.moduleSelected.id) === -1) {
        this.updateStateIfMounted({ moduleSelected: null });
      }
    }
  }

  filterCategories(categories) {
    const _categories = (categories || []).map(cat => {
      let categoryData = (cat || {});
      if (categoryData.hasOwnProperty('rawData')) {
        categoryData = categoryData.rawData;
      }
      return new ProductCategory(categoryData);
    });
    return _categories.filter(c => (c?.references || []).length);
  }

  refreshModules(questionsWithAnswers) {
    this.props.getModules(this.props.configuration.id, this.buildCriteriaPayload(questionsWithAnswers), this.props.selectedIOIslandSlot)
      .then((payload) => {
        let categories = [];
        let remainingCriteria = [];
        let sharedOptions = {};
        switch (this.props.moduleType) {
          case configurationModuleType.io_module:
            categories = payload.ioModules.categories;
            remainingCriteria = payload.ioModules.remainingCriteria;
            sharedOptions = payload.ioModules.sharedCriteria;
            break;
          case configurationModuleType.com_module:
            categories = payload.comModules.categories;
            remainingCriteria = payload.comModules.remainingCriteria;
            sharedOptions = payload.comModules.sharedCriteria;
            break;
          case configurationModuleType.cartridges:
            categories = payload.cartridges.categories;
            remainingCriteria = payload.cartridges.remainingCriteria;
            sharedOptions = payload.cartridges.sharedCriteria;
            break;
          default:
            break;
        }

        const allReferences = [];
        for (let category of categories) {
          allReferences.push(...category.references);
        }
        this.updateStateIfMounted({ categories: this.filterCategories(categories), remainingCriteria, sharedOptions });
        this.removeSelectedModuleIfNotInResult(allReferences);
      });
  }

  updateStateIfMounted(objectToAffect) {
    if (this._isMounted) {
      return this.setState(objectToAffect);
    }
  }

  getQuestionMap() {
    const questionMap = {};
    for (const questionCategory of this.props.questions.aggregatedQuestions) {
      for (const question of questionCategory.questions) {
        questionMap[question.questionKey] = question;
      }
    }
    return questionMap;
  }

  buildCriteriaPayload(questionsWithAnswers) {
    const questionMap = this.getQuestionMap();
    const payload = {};
    for (const [key, answer] of Object.entries(questionsWithAnswers)) {
      payload[questionMap[key].criteria] = answer;
    }
    return payload;
  }

  get numberQuestionsAnswered() {
    return Object.keys(this.state.questionsWithAnswers).length;
  }

  get haveQuestionsAnswered() {
    return !!Object.keys(this.state.questionsWithAnswers).length;
  }

  onAnswerChanged = (questionsWithAnswers) => {
    this.updateStateIfMounted({ questionsWithAnswers: questionsWithAnswers });
    this.refreshModules(questionsWithAnswers);
  }

  resetQuestionAnswers() {
    this.onAnswerChanged({});
  }

  get hasSelection() {
    return this.state.moduleSelected !== null;
  }

  handleSearchChange = (event) => {
    this.setState({ search: event.currentTarget.value });
  }

  renderModules = () => {
    const appLocale = getAppLocale();
    const categories = this.state.categories || [];
    const eligibleCategories = computeEligibleCategories(categories, this.state.search, this.props.configuration.showPrecommercializedProducts) || [];

    if (!this.props.compatibleModules.isLoading && !this.props.compatibleIslandModules.isLoading && !this.props.questions.isLoading) {
      if (!categories.length && !this.haveQuestionsAnswered) {
        return <p>{I10n.getAndReplace(`modal.${this.state.baseKey}.suggest.empty`, appLocale)}</p>;
      }
      if (!eligibleCategories.length) {
        return <p>{I10n.get(`modal.${this.state.baseKey}.suggest.no-match`)}</p>;
      }
    }

    return eligibleCategories.map(category => {
      return <ModuleCategory
        id={category.translationKey}
        title={I10n.getOrDefault(`category.${category.translationKey}.name`, category.label, 'data')}
        label={category.label}
        description={I10n.getOrDefault(`category.${category.translationKey}.description`, category.description, 'data')}
        detailedDescription={category.detailedDescription}
        image={category.imageURL}
        references={category.references}
        setSelectedDevice={(mod) => {
          if (mod !== null) {
            let moduleSelectedMaxAmount = 1;
            if ((category.maxQuantityForReferences || {}).hasOwnProperty(mod.id)) {
              moduleSelectedMaxAmount = category.maxQuantityForReferences[mod.id];
            }
            this.setState({ moduleSelected: mod, moduleSelectedMaxAmount, selectedDeviceAmount: 1 });
          } else {
            this.setState({ moduleSelected: null });
          }
        }}
        selectedDevice={this.state.moduleSelected}
        key={category.label}
        withCount={true}
        onOpenStateChange={(isOpen, ref) => {
          this.forceUpdate();
          if (isOpen) {
            setTimeout(() => {
              this.scrollComponent.view.scrollTop = ref.current.offsetTop;
            }, 0);
          }
        }}
        // Do not use force forceOpen to open if still loading
        forceOpen={!this.props.questions.isLoading && (this.haveQuestionsAnswered || eligibleCategories.length === 1)}
        boundingElementTooltip={this.deviceSectionElement}
      ></ModuleCategory>
    });
  }

  renderPossibleDeviceAmount = (maxAmount) => {
    const possibleAmounts = [...Array(maxAmount).keys()].map(i => ++i);
    return possibleAmounts.map((amount) => {
      return (
        { value: amount, label: amount}
      );
    });
  }

  toggleMobileFilter = (status) => {
    this.updateStateIfMounted({ mobileFilterOpened: status });
  }

  renderMobileQuestionButton = () => {
    return  <ContentWrapperMobile id='ContentWrapper-Mobile' fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>

    {(this.props.questions.isLoading || this.props.questions.aggregatedQuestions.length) > 0 &&
  <SearchBarTestWrapperMobile id='SearchBarTestWrapper-Mobile'>
    <FilterHeadWrapperMobile id='FilterHeadWrapper-Mobile' isHidden={this.state.isFilterOpen} onClick={() => this.setState(prevState => ({ isFilterOpen: !prevState.isFilterOpen }))}>
      <FilterHead
      isLoading={this.props.isLoading}
      toggleFilter={this.toggleFilter}
      numberQuestionsAnswered={this.numberQuestionsAnswered}
      />
    </FilterHeadWrapperMobile>
  <SearchBarWrapperMobile id='SearchBarWrapper-Mobile'>
      <SearchBarMobile id='SearchBar-Mobile'>
        <SearchBarIcon id='SearchBarIcon-Mobile'>
        <MsxIcons name="search" size="small"></MsxIcons>
        </SearchBarIcon>
        <SearchReferenceInput
          id="head-device-selector-screen-search-input"
          type="search"
          placeholder={I10n.get(`modal.add_module.search.placeholder`)}
          value={this.state.search}
          onChange={this.handleSearchChange}
          style={{ paddingLeft: '50px' }}
          color='#E6E6E6'
        ></SearchReferenceInput>
      </SearchBarMobile>
    </SearchBarWrapperMobile>
    {shouldShowPrecommToggle(this.state.categories) && <MobilePrecommWrapper>
        <PrecommercializationWarning
          showPrecommercializedProducts={this.props.configuration.showPrecommercializedProducts}
          disabled={this.props.configurationSaver?.isSaving}
          onToggle={() => {
            this.props.setShowPrecommercializedProducts(
              !this.props.configuration.showPrecommercializedProducts
            );
          }}
          boundingElement={this.modalWrapperElement}
        ></PrecommercializationWarning>
    </MobilePrecommWrapper>}
    </SearchBarTestWrapperMobile>}
  </ContentWrapperMobile>
  }

  render = () => {
    const {aggregatedQuestions = [] } = this.props.questions || {};
    const hasQuestions = aggregatedQuestions.length > 0;
    return (
      <Container ref={c => { this.modalWrapperElement = c }}>
        <Header id="modal-add-module-header">
          <TitleWrapper id="modal-add-module-titleWrapper">
            <Title>{I10n.get(`modal.${this.state.baseKey}.title`)}</Title>
            {!this.props.disableCrossModal && (
              <CloseIcon onClick={(e) => {
                e.preventDefault();
                this.props.closeModal();
              }}>
                <MsxIcons name="close"></MsxIcons>
              </CloseIcon>
            )}
          </TitleWrapper>
          <Subtitle>{I10n.getOrDefault(`modal.${this.props.configuration.starterType}.subtitle`, I10n.get('modal.subtitle'))}</Subtitle>
        </Header>
        <Body>
          <ContentWrapper id="modal-add-module-ContentWrapper">
            <SearchBarTestWrapper id='modal-add-module-SearchBarTestWrapper'>
              {hasQuestions && <Test id="modal-add-module-Test">
                <FilterHeadWrapper id="modal-add-module-FilterHeadWrapper"
                  isHidden={this.state.isFilterOpen}
                  onClick={() => this.setState(prevState => ({ isFilterOpen: !prevState.isFilterOpen }))}
                >
                  <FilterHead
                    isLoading={this.props.isLoading}
                    toggleFilter={this.toggleFilter}
                    numberQuestionsAnswered={this.numberQuestionsAnswered}
                  />
                </FilterHeadWrapper>
              </Test>}
              <SearchBarWrapper>
                  <SearchBar id='AddModal 2'>
                    <SearchBarIcon>
                      <MsxIcons name="search" size="small"></MsxIcons>
                    </SearchBarIcon>
                    <SearchReferenceInput
                      id="add-modal-screen-search-input"
                      type="search"
                      placeholder={I10n.get(`modal.${this.state.baseKey}.search.placeholder`)}
                      value={this.state.search}
                      onChange={this.handleSearchChange}
                      style={{ paddingLeft: '50px' }}
                      color='#E6E6E6'
                    ></SearchReferenceInput>
                  </SearchBar>
                  {shouldShowPrecommToggle(this.state.categories) && <PrecommWrapper>
                    <PrecommercializationWarning
                      showPrecommercializedProducts={this.props.configuration.showPrecommercializedProducts}
                      disabled={this.props.configurationSaver?.isSaving}
                      onToggle={() => {
                        this.props.setShowPrecommercializedProducts(
                          !this.props.configuration.showPrecommercializedProducts
                        ).then(() => {
                          this.refreshModules(this.state.questionsWithAnswers);
                        });
                      }}
                      boundingElement={this.modalWrapperElement}
                    ></PrecommercializationWarning>
                  </PrecommWrapper>}
              </SearchBarWrapper>
            </SearchBarTestWrapper>
          </ContentWrapper>
          <Content id="modal-add-module-content">
          {hasQuestions && (
            <FilterContentWrapper id='modal-add-module-filterContentWrapper'
              isFilterOpen={this.state.isFilterOpen}
            >
              <FilterContent
                isFilterOpen={this.state.isFilterOpen}
                aggregatedQuestions={this.props.questions.aggregatedQuestions}
                isLoading={this.props.questions.isLoading}
                onAnswerChanged={this.onAnswerChanged}
                questionsWithAnswers={this.state.questionsWithAnswers}
                questionMap={this.getQuestionMap()}
                resultsLoading={this.props.compatibleModules.isLoading || this.props.compatibleIslandModules.isLoading}
                remainingOptions={this.state.remainingCriteria}
                sharedOptions={this.state.sharedOptions}
                resetQuestionAnswers={this.resetQuestionAnswers}
                mobileFilterOpened={this.state.mobileFilterOpened}
                toggleMobileFilter={this.toggleMobileFilter}
                toggleFilter={() => this.setState(prevState => ({ isFilterOpen: !prevState.isFilterOpen }))}
              />
            </FilterContentWrapper>
          )}
            <DeviceSection isFilterOpen={this.state.isFilterOpen}>
              <MobileQuestionManagement>
                {!this.props.questions.isLoading && this.props.questions?.aggregatedQuestions?.length > 0 && this.renderMobileQuestionButton()}
              </MobileQuestionManagement>
              <DeviceSectionContent ref={c => {this.deviceSectionElement = c;}}>
                {(this.props.compatibleModules.isLoading || this.props.compatibleIslandModules.isLoading) &&
                  <LoadingMask>
                    <LoadingSpinner></LoadingSpinner>
                  </LoadingMask>
                }
                <Scrollbars ref={c => { this.scrollComponent = c }}>
                  {this.renderModules()}
                </Scrollbars>
              </DeviceSectionContent>
            </DeviceSection>
          </Content>
          <NavigationButtonSection>
            <AddModuleSection>
              {this.hasSelection && this.state.moduleSelectedMaxAmount > 1 && !this.props.hideQuantity &&
                (
                  <MultipleAdditionWrapper>
                    <QuantityLabel>
                      {I10n.get(`modal.add_module.quantity`)}
                    </QuantityLabel>
                    <Select instanceId="modal-add-module-quantity-select" value={{ value: this.state.selectedDeviceAmount, label: this.state.selectedDeviceAmount}}
                      onChange={(e) => {
                        this.setState({ selectedDeviceAmount: +e.value });
                      }}
                      styles={{control: (provided, state) => {
                        return { ...provided, marginRight: 10, minHeight: 40 };
                      }}}
                      options={this.renderPossibleDeviceAmount(this.state.moduleSelectedMaxAmount)}
                      isSearchable={false}
                      menuPlacement={"auto"}
                    >
                    </Select>
                  </MultipleAdditionWrapper>
                )
              }
              <Button id="modal-add-module-add-button" importance="emphasized" primary disabled={!this.hasSelection}
                onClick={event => {
                  this.props.addDevices(this.state.moduleSelected, this.state.selectedDeviceAmount);
                  this.props.closeModal();
                }}
              >
                {this.hasSelection ? I10n.getAndReplace(`modal.${this.state.baseKey}.add_label`, this.state.selectedDeviceAmount) : I10n.get(`modal.${this.state.baseKey}.select_module`)}
              </Button>
            </AddModuleSection>
          </NavigationButtonSection>
        </Body>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return state;
};

const mapDispatchToProps = dispatch => {
  return {
    getAggregatedQuestions: (questionType) => dispatch(getQuestions(questionType)),
    getModules: (configurationID, criteria, specificIslandSlot) => dispatch(getCompatibleModules(configurationID, criteria, false, specificIslandSlot)),
    setShowPrecommercializedProducts: (newStatus) => dispatch(setShowPrecommercializedProducts(newStatus))
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(ModalAddModule);
